import { defineMessages } from 'react-intl'

export default defineMessages({
  title: {
    id: 'OrganizationUserAttributes.Title',
    defaultMessage: 'User Attributes'
  },
  loading: {
    id: 'Loading',
    defaultMessage: 'Loading...'
  },
  back: {
    id: 'Back',
    defaultMessage: 'Back'
  },
  createButton: {
    id: 'OrganizationUserAttributes.CreateAttribute',
    defaultMessage: 'Create Attribute'
  },
  confirmDeleteTitle: {
    id: 'OrganizationUserAttributes.ConfirmDeleteTitle',
    defaultMessage: 'Really want to remove?'
  },
  confirmDeleteMessage: {
    id: 'OrganizationUserAttributes.ConfirmDeleteMessage',
    defaultMessage: 'This attribute and all user data associated with it will be removed for your organization.'
  },
  errorTitle: {
    id: 'UnrecoverableError.Title',
    defaultMessage: 'Something went wrong...'
  },
  errorMessage: {
    id: 'UnrecoverableError.Message',
    defaultMessage: "It's not you, it's us. There was a problem with the system which caused your request to fail."
  }
})
